(function($){
    const fn = $(".part_player_audio");

    if (fn.length) {
        fn.each(function () {
            libPlayerAudio($(this)[0]);
        })
    }
})(jQuery);